import { format, add } from 'date-fns';
import { TimeFilter } from '@shared/models/time-filter';

export class ClassroomCourseFilter {
  constructor() {
    this.search = '';
    this.locations = [];
    this.languages = [];
    this.onlyPublished = true;
    this.onlyPending = false;
    this.onlyWithAvailableSlot = true;
    this.pageIndex = 0;
    this.pageSize = 10;
    (this.fromDate = ''), (this.toDate = '');
    this.dateFilter = format(add(new Date(), { days: 1 }), 'yyyy-MM-dd');
    this.times = [];
    this.cities = [];
    this.capacity = null;
    this.sort = 'random';
    this.templateId = ''
  }
  search: string;
  locations?: string[];
  capacity?: number;
  languages?: string[];
  onlyPublished: boolean;
  onlyPending: boolean;
  onlyWithAvailableSlot: boolean;
  pageIndex: number;
  pageSize: number;
  fromDate: string;
  toDate: string;
  dateFilter: string;
  times?: TimeFilter[];
  cities?: string[];
  sort: string;
  templateId?: string;
  categories?: string;
}
